import React, {FC} from 'react';
import { BoundSearchQuery } from "../../../types/common/BoundSearchQuery";
import { PendingInventoryActivitySearchCriteria  } from "../../../types/model/criteria/pendinginventoryactivity/PendingInventoryActivitySearchCriteria";
import { PageableParams } from "../../../types/model/params/PageableParams";
import { optionsEndpoints } from "../../../requests/api-endpoints";
import {
  SortFilterContainer,
  SortFilterItemContainer,
  SortFilterRowContainer
} from "../../common/reports/sortFilter";
import {
  sortByFields,
  PendingInventoryActivitySortByType,
  PendingInventoryActivitySortParams
} from "../../../types/model/params/sortParams/PendingInventoryActivitySortParams";
import {
  BoundGateEventTypeSelect,
  BoundGateEventValidationErrorSelect,
  BoundPendingInventoryActivityStatusSelect,
  BoundSortSelect,
  BoundDataDrivenAutocomplete,
  BoundTextInput,
  BoundDatePicker
} from "../../common/inputs/boundInputs";

export interface SupplierPendingInventoryActivitySearchParams extends PendingInventoryActivitySearchCriteria , PendingInventoryActivitySortParams, PageableParams, BoundSearchQuery {}

export interface SupplierPendingInventoryActivitySortFilterProps {
  query: SupplierPendingInventoryActivitySearchParams;
  onChange: (newQuery: SupplierPendingInventoryActivitySearchParams) => void;
}

const SupplierPendingInventoryActivitySortFilter: FC<SupplierPendingInventoryActivitySortFilterProps> = ({
  query,
  onChange
}) => {
  return <SortFilterContainer>
    <SortFilterRowContainer>
      <SortFilterItemContainer>
        <BoundDataDrivenAutocomplete<SupplierPendingInventoryActivitySearchParams>
          label="Location"
          requestUrl={optionsEndpoints.supplier.location}
          name="locationId"
          value={query?.locationId}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundDatePicker<SupplierPendingInventoryActivitySearchParams>
          label="Start Date"
          name="startDate"
          value={query?.startDate}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundDatePicker<SupplierPendingInventoryActivitySearchParams>
          label="End Date"
          name="endDate"
          value={query?.endDate}
          onChange={onChange}
        />
      </SortFilterItemContainer>
    </SortFilterRowContainer>
    <SortFilterRowContainer>
      <SortFilterItemContainer>
        <BoundTextInput<SupplierPendingInventoryActivitySearchParams>
          label="Booking Number"
          name="bookingNumber"
          value={query?.bookingNumber}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundTextInput<SupplierPendingInventoryActivitySearchParams>
          label="Equipment Number"
          name="equipmentNumber"
          value={query?.equipmentNumber}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundGateEventValidationErrorSelect<SupplierPendingInventoryActivitySearchParams>
          name="errorCode"
          value={query?.errorCode}
          onChange={onChange}
        />
      </SortFilterItemContainer>
    </SortFilterRowContainer>
    <SortFilterRowContainer>
      <SortFilterItemContainer>
        <BoundGateEventTypeSelect<SupplierPendingInventoryActivitySearchParams>
          name="eventType"
          value={query?.eventType}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundPendingInventoryActivityStatusSelect<SupplierPendingInventoryActivitySearchParams>
          name="status"
          value={query?.status}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundSortSelect<SupplierPendingInventoryActivitySearchParams, PendingInventoryActivitySortByType>
          query={query}
          defaultSortBy="EVENT_DATETIME"
          defaultSortDir="desc"
          sortByFields={sortByFields}
          onChange={onChange}
        />
      </SortFilterItemContainer>
    </SortFilterRowContainer>
  </SortFilterContainer>
}

export { SupplierPendingInventoryActivitySortFilter };